class WrappedCartItem extends HTMLElement {
  constructor() {
    super()
    this.wrappedCartItem = this
    const div = document.createElement('div')

    if (this.closest('#main-cart-items')) {
      // if the line item is on the cart page then add the wrapped cart page item widget
      div.removeAttribute('data-position')
      div.setAttribute('data-position', 'cart-item')
      this.append(div)
    } else {
      // if the line item is on the cart drawer then add the wrapped cart drawer item widget
      div.removeAttribute('data-position')
      div.setAttribute('data-position', 'cart-item-drawer')
      this.append(div)
    }
    // Create custom icons for gift message and gift wrap
    const setupIcons = () => {
      this.setupMessageOnly(this)
      this.setupGiftWrap(this)
    }
    const updateGift = (wrappedElement) => {
      const wrappedItem = wrappedElement.closest('tr')
      const removeBtn = wrappedItem.querySelector('cart-remove-button')
      const qtyBtn = wrappedItem.querySelector('quantity-input')
      const qtyInput = qtyBtn.querySelector('input')
      const line = removeBtn.dataset.index
      const qty = qtyInput.value
      const cartItems =
        wrappedItem.closest('cart-items') ||
        wrappedItem.closest('cart-drawer-items')
      cartItems.updateQuantity(
        line,
        qty,
        document.activeElement.getAttribute('name')
      )
    }
    // Create a mutation observer to observe the DOM and setup custom icons once the widget has been injected
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.target.nodeName ===
            'WRAPPED-FEATURE-SENDER-RECEIVER-SIMPLE' &&
          mutation.addedNodes.length
        ) {
          setupIcons()
        }
        if (
          mutation.target.nodeName === 'WRAPPED-FEATURE-CHECKBOX-SIMPLE' &&
          mutation.addedNodes.length
        ) {
          // Get the element with the class 'wrapped-cart-line-provider'
          const element = document.querySelector(
            `wrapped-extension[uuid="${mutation.target.block.id}"] wrapped-cart-line-provider`
          )

          // Add a click event listener to the element
          element.addEventListener('click', function () {
            // Dispatch the change event
            setTimeout(() => {
              updateGift(element)
            }, 1200)
          })
        }
      })
    })

    observer.observe(this, {
      childList: true,
      subtree: true,
      attributes: true,
    })
  }
  // Create message icon element
  createMessageIcon = () => {
    const messageSvg = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'svg'
    )
    // ... setup messageSvg attributes ...
    messageSvg.setAttribute('width', '16')
    messageSvg.setAttribute('height', '15')
    messageSvg.setAttribute('viewBox', '0 0 16 15')
    messageSvg.setAttribute('fill', 'none')
    messageSvg.style.marginRight = '10px'
    messageSvg.style.marginLeft = '1px'

    // Create the path element
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path')
    path.setAttribute(
      'd',
      'M8 3.92832C8 3.15168 7.705 2.40685 7.1799 1.85769C6.6548 1.30852 5.94261 1 5.2 1H1V11.9812H5.9C6.45695 11.9812 6.9911 12.2126 7.38492 12.6245C7.77875 13.0363 8 13.595 8 14.1774M8 3.92832V14.1774M8 3.92832C8 3.15168 8.295 2.40685 8.8201 1.85769C9.3452 1.30852 10.0574 1 10.8 1H15V11.9812H10.1C9.54305 11.9812 9.0089 12.2126 8.61508 12.6245C8.22125 13.0363 8 13.595 8 14.1774'
    )
    path.setAttribute('stroke', '#1E1E1E')
    path.setAttribute('stroke-width', '1.46416')
    path.setAttribute('stroke-linecap', 'round')
    path.setAttribute('stroke-linejoin', 'round')

    // Append the path to the SVG
    messageSvg.appendChild(path)

    return messageSvg
  }

  // Create gift wrap image element
  createGiftWrapImage = () => {
    const img = new Image()
    let shopUrl = window.location.href
    if (shopUrl.includes('dev')) {
      img.src =
        'https://cdn.shopify.com/s/files/1/0770/2878/6454/files/Screenshot_2024-09-09_at_2.46.52_PM_3_2.png?v=1727308999'
    } else {
      img.src =
        'https://cdn.shopify.com/s/files/1/0769/0659/4596/files/Screenshot_2024-09-09_at_2.46.52_PM_3_2.png?v=1727457221'
    }
    img.style.width = '18px'
    img.style.height = '18px'
    img.style.marginRight = '10px'
    return img
  }

  // Setup message only element
  setupMessageOnly = (wrappedCartItem) => {
    let shopUrl = window.location.href
    let disableGiftMessage = '49919364825380'

    if (shopUrl.includes('dev')) {
      disableGiftMessage = '49141998190870'
    }

    const messageOnly = wrappedCartItem.querySelector(
      `[data-variant-id="${disableGiftMessage}"]`
    )
    if (messageOnly && !messageOnly.querySelector('svg')) {
      const title = messageOnly.querySelector('span[part="title"]')
      if (title) {
        const messageSvg = this.createMessageIcon()
        title.prepend(messageSvg)
      }
    }
  }

  // Setup gift wrap element
  setupGiftWrap = (wrappedCartItem) => {
    let shopUrl = window.location.href
    let disableGiftWrap = '49919347261732'

    if (shopUrl.includes('dev')) {
      disableGiftWrap = '46392720195862'
    }

    const giftWrap = wrappedCartItem.querySelector(
      `[data-variant-id="${disableGiftWrap}"]`
    )
    if (giftWrap) {
      const giftTitle = giftWrap.querySelector('span[part="title"]')
      if (!giftTitle.querySelector('img')) {
        const img = this.createGiftWrapImage()
        giftTitle.prepend(img)
      }
    }
  }
}

if (!customElements.get('wrapped-cart-item')) {
  customElements.define('wrapped-cart-item', WrappedCartItem)
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super()
  }

  handleClick = async (event) => {
    event.preventDefault()
    const cartItems =
      this.closest('cart-items') || this.closest('cart-drawer-items')
    const isMattress = this.dataset.isMattress ? true : false
    const isBundle = this.dataset.bundle ? true : false
    if (isMattress) {
      // Use the improved mattress removal logic
      await this.removeMattressProductAndFees(
        parseInt(this.dataset.index),
        cartItems
      )
    } else if (isBundle) {
      cartItems.updateQuantity(this.dataset.index, 0)
      const urlParams = new URLSearchParams(window.location.search)
      if (urlParams.has('edit')) {
        setTimeout(() => {
          urlParams.delete('edit')
          window.location.href = `${window.location.pathname}?${urlParams.toString()}`
        }, 1000)
      } else {
        setTimeout(() => {
          window.location.reload()
        }, 1000)
      }
    } else {
      cartItems.updateQuantity(this.dataset.index, 0)
    }

    const cartItem = document.querySelector('[data-cart-item]')
    if (!cartItem) {
      const giftWrapperTrigger = document.querySelector(
        "wrapped-extension-block[data-target-group='cart-page']"
      )
      if (giftWrapperTrigger) giftWrapperTrigger.style.display = 'none'
    }
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick.bind(this))
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick.bind(this))
  }

  async removeMattressProductAndFees(mattressLineIndex, cartItems) {
    try {
      const cartResponse = await fetch('/cart.js')
      if (!cartResponse.ok) {
        await cartItems.updateQuantity(mattressLineIndex, 0)
        return
      }

      const cartData = await cartResponse.json()
      if (!cartData || !cartData.items) {
        await cartItems.updateQuantity(mattressLineIndex, 0)
        return
      }

      const mattressItem = cartData.items[mattressLineIndex - 1]
      if (!mattressItem) {
        return
      }

      const mattressVariantId = mattressItem.variant_id
      const mattressFeeItem = document.querySelector(
        '[data-mattress-fee-variant]'
      )
      const mattressRemovalItem = document.querySelector(
        '[data-removal-fee-variant]'
      )

      const mattressFeeVariantId = mattressFeeItem
        ? parseInt(mattressFeeItem.getAttribute('data-mattress-fee-variant'))
        : null
      const mattressRemovalVariantId = mattressRemovalItem
        ? parseInt(mattressRemovalItem.getAttribute('data-removal-fee-variant'))
        : null

      let variantsToRemove = []

      if (mattressFeeVariantId) {
        variantsToRemove.push(mattressFeeVariantId)
      }
      if (mattressRemovalVariantId) {
        variantsToRemove.push(mattressRemovalVariantId)
      }
      variantsToRemove.push(mattressVariantId)

      const otherMattressItems = cartData.items.filter(
        (item) =>
          item.variant_id !== mattressVariantId &&
          item.product_type === 'Mattress'
      )
      const qtyOfOtherMattressItems = otherMattressItems.reduce(
        (total, item) => total + item.quantity,
        0
      )

      const hasOtherMattressItems = otherMattressItems.length > 0
      let shouldUpdateFeeInput = false
      const mattressFeeInCart = cartData.items.find(
        (item) => item.variant_id === mattressFeeVariantId
      )

      if (mattressFeeVariantId && hasOtherMattressItems) {
        const maxQty = mattressFeeInCart?.quantity_rule?.max
          ? mattressFeeInCart.quantity_rule.max
          : null
        const quantityDiffers =
          mattressFeeInCart.quantity !== qtyOfOtherMattressItems
        const isUnderMaxQty =
          maxQty !== null && qtyOfOtherMattressItems < maxQty
        const withinMaxQty =
          maxQty === null || qtyOfOtherMattressItems <= maxQty

        if ((quantityDiffers || isUnderMaxQty) && withinMaxQty) {
          shouldUpdateFeeInput = true
        }
        // remove mattressFeeVariantId from variantsToRemove
        variantsToRemove = variantsToRemove.filter(
          (variantId) => variantId !== mattressFeeVariantId
        )
      }

      if (shouldUpdateFeeInput && mattressFeeInCart) {
        const updates = {
          [mattressFeeInCart.key]: qtyOfOtherMattressItems,
        }

        const feeResponse = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ updates }),
        })
        if (feeResponse.ok) {
          await cartItems.removeMattressRelatedItems(variantsToRemove)
        } else {
          await cartItems.updateQuantity(mattressLineIndex, 0)
        }
      } else {
        await cartItems.removeMattressRelatedItems(variantsToRemove)
      }
    } catch (error) {
      console.error('Failed to remove mattress products and fees:', error)
      try {
        await cartItems.updateQuantity(mattressLineIndex, 0)
      } catch (fallbackError) {
        console.error(
          'Failed to remove even the main mattress product:',
          fallbackError
        )
      }
    }
  }
}
customElements.define('cart-remove-button', CartRemoveButton)
class CartItems extends HTMLElement {
  constructor() {
    super()
    this.cartItems = this
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') ||
      document.getElementById('CartDrawer-LineItemStatus')

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0)

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event)
    }, 300)

    this.addEventListener('change', this.debouncedOnChange.bind(this))
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name'),
      event.target.hasAttribute('data-mattress')
    )
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'FreeShipping-main',
        section: 'free-shipping',
        selector: 'free-shipping',
      },
    ]
  }

  updateQuantity = async (line, quantity, name, isMattress = false) => {
    this._recordLastFocusedElement()
    this.enableLoading(line)
    const cartDrawerWrapper = document.querySelector('cart-drawer')
    const cartFooter = document.getElementById('main-cart-footer')
    const items = document.querySelectorAll('[data-cart-item]')

    const quantityElement =
      document.getElementById(`Quantity-${line}`) ||
      document.getElementById(`Drawer-quantity-${line}`)

    // Check if this is a mattress product being reduced to 0
    const currentLineItem = document.querySelector(`#CartItem-${line}`)
    const isMattressReduction = this.shouldRemoveMattressRelatedItems(
      currentLineItem,
      quantity
    )

    if (isMattressReduction) {
      const cartResponse = await fetch('/cart.js')
      if (cartResponse.ok) {
        const cartData = await cartResponse.json()
        const mattressItem = cartData.items[line - 1]
        if (mattressItem) {
          const mattressVariantId = mattressItem.variant_id
          const mattressRelatedVariants =
            await this.getMattressRelatedVariants()
          const allVariantsToRemove = [
            ...mattressRelatedVariants,
            mattressVariantId,
          ]
          await this.removeMattressRelatedItems(allVariantsToRemove)
          return
        }
      }
    }

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    })

    try {
      // Post changes to cart
      const changeResponse = await fetch(`${routes.cart_change_url}`, {
        ...fetchConfig(),
        ...{ body },
      })
      const responseData = await changeResponse.json()
      if (!changeResponse.ok) {
        quantityElement.value = quantityElement.getAttribute('value')
        this.updateLiveRegions(
          line,
          responseData.errors || changeResponse.statusText
        )
        return
      }

      // Get updated cart after touching checkout to fix pricing
      const getCartResponse = await fetch(routes.cart_url, fetchConfig())
      if (!getCartResponse.ok) {
        quantityElement.value = quantityElement.getAttribute('value')
        this.updateLiveRegions(line, getCartResponse.statusText)
        return
      }

      const parsedGetCartResponse = await getCartResponse.json()
      // Publish cart updates
      this.publishEvent(parsedGetCartResponse)

      // Get section updates
      const sectionIds = this.getSectionsToRender().map(
        (section) => section.section
      )
      const sectionUpdateResponse = await fetch(`/?sections=${sectionIds}`, {
        headers: { Accept: 'application/json' },
      })

      if (!sectionUpdateResponse.ok) {
        quantityElement.value = quantityElement.getAttribute('value')
        this.updateLiveRegions(line, getCartResponse.statusText)
        return
      }

      const sectionUpdateData = await sectionUpdateResponse.json()
      const feeUpdated = isMattress
        ? await this.recalculateMattressFees(parsedGetCartResponse)
        : false
      // Render section updates

      if (!isMattress || !feeUpdated) {
        this.renderContents({ sections: sectionUpdateData })
      } else {
        const refreshedSectionResponse = await fetch(
          `/?sections=${sectionIds}`,
          {
            headers: { Accept: 'application/json' },
          }
        )
        if (refreshedSectionResponse.ok) {
          const refreshedSectionData = await refreshedSectionResponse.json()
          this.renderContents({ sections: refreshedSectionData })
        } else {
          this.renderContents({ sections: sectionUpdateData })
        }
      }
      // Handle cart updates based on state values
      this.setAttribute('data-empty', parsedGetCartResponse.item_count === 0)

      if (cartFooter)
        cartFooter.setAttribute(
          'data-empty',
          parsedGetCartResponse.item_count === 0
        )
      if (cartDrawerWrapper)
        cartDrawerWrapper.setAttribute(
          'data-empty',
          parsedGetCartResponse.item_count === 0
        )

      const updatedValue = parsedGetCartResponse.items[line - 1]
        ? parsedGetCartResponse.items[line - 1].quantity
        : undefined
      let message = ''
      if (
        items.length === parsedGetCartResponse.items.length &&
        updatedValue !== parseInt(quantityElement.value)
      ) {
        if (typeof updatedValue === 'undefined') {
          message = window.cartStrings.error
        } else {
          message = window.cartStrings.quantityError.replace(
            '[quantity]',
            updatedValue
          )
        }
      }
      this.updateLiveRegions(line, message)

      this.disableLoading()
    } catch (e) {
      console.log(e)
      const errors =
        document.getElementById('cart-errors') ||
        document.getElementById('CartDrawer-CartErrors')
      errors.textContent = window.cartStrings.error
      this.disableLoading()
    } finally {
      this.disableLoading(line)
      // setTimeout(() => {
      //   const lineItemAnchor = document.getElementById(`CartItem-${line}`)
      //   if (lineItemAnchor) {
      //     lineItemAnchor.scrollIntoView({ behavior: 'smooth' })
      //   }
      // }, 500)
    }
  }

  shouldRemoveMattressRelatedItems(lineItem, quantity) {
    const numQuantity = Number(quantity)
    if (!lineItem || numQuantity !== 0) {
      return false
    }

    const removeButton = lineItem.querySelector('cart-remove-button')
    return removeButton && removeButton.hasAttribute('data-is-mattress')
  }

  async getMattressRelatedVariants() {
    try {
      const mattressFeeItem = document.querySelector(
        '[data-mattress-fee-variant]'
      )
      const mattressRemovalItem = document.querySelector(
        '[data-removal-fee-variant]'
      )

      const mattressFeeVariantId = mattressFeeItem
        ? parseInt(mattressFeeItem.getAttribute('data-mattress-fee-variant'))
        : null
      const mattressRemovalVariantId = mattressRemovalItem
        ? parseInt(mattressRemovalItem.getAttribute('data-removal-fee-variant'))
        : null

      const variantIds = []
      if (mattressFeeVariantId) {
        variantIds.push(mattressFeeVariantId)
      }
      if (mattressRemovalVariantId) {
        variantIds.push(mattressRemovalVariantId)
      }

      return variantIds
    } catch (error) {
      console.error('Error getting mattress related variants:', error)
      return []
    }
  }

  async removeMattressRelatedItems(variantIds) {
    console.log('Removing mattress-related variants:', variantIds)

    try {
      // Get current cart to find the correct keys
      const cartResponse = await fetch('/cart.js')
      if (!cartResponse.ok) {
        console.warn('Failed to fetch cart for key mapping')
        return
      }
      const cartData = await cartResponse.json()

      // Build updates object for bulk removal
      const updates = {}
      let foundItems = 0

      for (const variantId of variantIds) {
        const cartItem = cartData.items.find(
          (item) => item.variant_id === variantId
        )
        if (cartItem) {
          updates[cartItem.key] = 0
          foundItems++
          console.log(
            `Found cart key for variant ${variantId}: ${cartItem.key}`
          )
        } else {
          console.warn(`Cart item not found for variant ${variantId}`)
        }
      }

      if (foundItems === 0) {
        console.warn('No mattress items found in cart to remove')
        return
      }

      // Sequential removal with animations - fees first, then mattress
      const cartKeysInOrder = []
      for (const variantId of variantIds) {
        const cartItemIndex = cartData.items.findIndex(
          (item) => item.variant_id === variantId
        )
        const cartItem = cartData.items[cartItemIndex]
        if (cartItem && updates[cartItem.key] !== undefined) {
          cartKeysInOrder.push({
            key: cartItem.key,
            variantId,
            lineIndex: cartItemIndex + 1, // Convert to 1-based for CartItem-{index}
          })
        }
      }

      // Add fade animations to ALL mattress items at once for immediate visual feedback
      const animatedElements = []
      for (const { lineIndex, variantId } of cartKeysInOrder) {
        const cartItemElement = document.querySelector(`#CartItem-${lineIndex}`)
        if (cartItemElement) {
          cartItemElement.classList.add('animate-fade')
          animatedElements.push({
            element: cartItemElement,
            lineIndex,
            variantId,
          })
        }
      }

      let lastResponse = null
      let successCount = 0

      for (const { key: cartKey, variantId, lineIndex } of cartKeysInOrder) {
        try {
          const removeBody = JSON.stringify({
            id: cartKey,
            quantity: 0,
            sections: this.getSectionsToRender().map(
              (section) => section.section
            ),
            sections_url: window.location.pathname,
          })

          const response = await fetch(`${routes.cart_change_url}`, {
            ...fetchConfig(),
            body: removeBody,
          })

          if (!response.ok) {
            const errorData = await response.json()
            console.error(
              `Failed to remove cart key ${cartKey}:`,
              response.status,
              errorData
            )
            // Find and remove animation if removal failed
            const failedElement = animatedElements.find(
              (el) => el.lineIndex === lineIndex
            )
            if (failedElement) {
              failedElement.element.classList.remove('animate-fade')
            }
            continue
          }

          lastResponse = response
          successCount++
          await new Promise((resolve) => setTimeout(resolve, 50))
        } catch (error) {
          console.error(`Error removing cart key ${cartKey}:`, error)
        }
      }

      if (!lastResponse) {
        console.error('All mattress removal calls failed')
        return
      }

      const responseData = await lastResponse.json()

      // Update the UI with the response data
      this.renderContents(responseData)

      // Update cart attributes
      this.setAttribute('data-empty', responseData.item_count === 0)
      const cartFooter = document.getElementById('main-cart-footer')
      if (cartFooter) {
        cartFooter.setAttribute('data-empty', responseData.item_count === 0)
      }
      const cartDrawerWrapper = document.querySelector('.drawer__contents')
      if (cartDrawerWrapper) {
        cartDrawerWrapper.setAttribute(
          'data-empty',
          responseData.item_count === 0
        )
      }
    } catch (error) {
      console.error('Failed to get cart data for mattress removal:', error)
    }
  }

  async recalculateMattressFees(cart) {
    const mattressItems = cart.items.filter(
      (item) => item.product_type === 'Mattress'
    )
    const mattressFeeItem = cart.items.find(
      (item) => item.product_type === 'Mattress Recycling Fee'
    )

    const mattressItemsQty = mattressItems.reduce(
      (total, item) => total + item.quantity,
      0
    )

    const maxQty = mattressFeeItem?.quantity_rule?.max
      ? mattressFeeItem.quantity_rule.max
      : null

    const quantityDiffers = mattressFeeItem.quantity !== mattressItemsQty

    const isUnderMaxQty = maxQty !== null && mattressItemsQty < maxQty
    const withinMaxQty = maxQty === null || mattressItemsQty <= maxQty

    if ((quantityDiffers || isUnderMaxQty) && withinMaxQty) {
      const updates = {
        [mattressFeeItem.key]: mattressItemsQty,
      }
      const feeResponse = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates }),
      })
      if (feeResponse.ok) {
        return true
      } else {
        return false
      }
    }
    return false
  }

  async renderContents(parsedState) {
    if (parsedState.sections) {
      const drawerScrollContainer = document.querySelector('cart-drawer-items')
      const savedScrollTop = drawerScrollContainer?.scrollTop ?? 0
      const originalOverflow = drawerScrollContainer?.style?.overflow ?? ''

      if (drawerScrollContainer) {
        drawerScrollContainer.style.overflow = 'hidden'
      }

      const renderDefer = defer()
      requestAnimationFrame(async () => {
        await this.customRender(parsedState)
        renderDefer.resolve()
      })

      await renderDefer.promise

      const scrollContainerAfterRender =
        document.querySelector('cart-drawer-items')
      if (scrollContainerAfterRender) {
        scrollContainerAfterRender.style.overflow = originalOverflow || ''
        if (savedScrollTop > 0) {
          scrollContainerAfterRender.scrollTop = savedScrollTop
        }
      }

      this._restoreFocusToLastElement()
    }
  }

  async customRender(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) ||
        document.getElementById(section.id)
      elementToReplace.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.section],
        section.selector
      )
    })
  }

  updateFeeInput() {
    const feeInput = document.querySelector('input[data-mattress-fee-qty]')
    if (feeInput) {
      const mattressFeeQuantityInput = feeInput.closest('quantity-input')

      let totalQuanty = []
      document
        .querySelectorAll('input[data-mattress]')
        .forEach((quantityInput) => {
          totalQuanty.push(parseInt(quantityInput.value, 10))
        })
      const newValue = totalQuanty.reduce((acc, curr) => acc + curr, 0)
      if (newValue !== feeInput.value) {
        feeInput.value = newValue
        feeInput.dispatchEvent(mattressFeeQuantityInput.changeEvent)
      }
    }
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`)
    const QTYError = document.getElementById(`Qty-Line-item-error-${line}`)
    if (lineItemError) {
      if (message) {
        lineItemError.setAttribute('data-show', true)
        lineItemError.querySelector('[data-cart-item-error-text]').innerHTML =
          message
        QTYError.setAttribute('disabled', '')
      } else {
        lineItemError.setAttribute('data-show', false)
      }
    }

    this.lineItemStatusElement.setAttribute('aria-hidden', true)

    const cartStatus =
      document.getElementById('cart-live-region-text') ||
      document.getElementById('CartDrawer-LiveRegionText')
    cartStatus.setAttribute('aria-hidden', false)

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true)
    }, 1000)
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML
  }

  enableLoading(line) {
    const cartItemElements = this.querySelectorAll(`#CartItem-${line}`)
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line}`
    )

    ;[...cartItemElements, ...cartDrawerItemElements].forEach((cartItem) =>
      cartItem.classList.add('animate-fade')
    )

    document.activeElement.blur()
    this.lineItemStatusElement.setAttribute('aria-hidden', false)
  }

  disableLoading() {
    const cartItemElements = document.querySelectorAll(`[data-cart-item]`)
    cartItemElements.forEach((cartItem) =>
      cartItem.classList.remove('animate-fade')
    )
  }

  publishEvent(response) {
    let detail = {}
    if (response.errors) {
      detail.errors = response.errors
    } else {
      detail.cart = response
    }
    const cartChange = new CustomEvent('cartchange', {
      detail: detail,
      bubbles: true,
    })
    this.dispatchEvent(cartChange)
  }

  _recordLastFocusedElement() {
    try {
      const activeElement = document.activeElement
      // Don't overwrite with body when we already recorded focus at start of updateQuantity (before blur)
      if (
        activeElement === document.body &&
        this.lastFocusedElementSelectorId
      ) {
        return
      }
      if (
        activeElement &&
        activeElement.id &&
        (document.body.contains(activeElement) ||
          activeElement === document.body)
      ) {
        this.lastFocusedElementSelectorId = activeElement.id
      }
    } catch (error) {
      console.error(error)
    }
  }

  _restoreFocusToLastElement() {
    try {
      if (this.lastFocusedElementSelectorId) {
        setTimeout(() => {
          const activeElement = document.getElementById(
            `${this.lastFocusedElementSelectorId}`
          )
          if (activeElement) {
            activeElement?.focus()
          } else {
            ;(firstFocusableElement(document.body) || document.body)?.focus()
          }

          this.lastFocusedElementSelectorId = null
        }, 50)
      }
    } catch (error) {
      console.error(error)
    }
  }
}

customElements.define('cart-items', CartItems)

class BundleEditButton extends HTMLElement {
  constructor() {
    super()
    this.editBundle = this
    this.editBundleURL = this.editBundle.dataset.productUrl
    this.editBundleVariantIds = this.editBundle.dataset.variantIds
    this.editProductId = this.editBundle.dataset.editProductId
  }
  connectedCallback() {
    //TODO: Update the line item with the variant image and description after editing the bundle data.
    this.editBundle.addEventListener('click', () => {
      const closestQuantityInput =
        this.closest('td').querySelector('quantity-input')
      const bundleQuantity = closestQuantityInput.querySelector('input').value
      const gids = []
      const regex = /gid:\/\/shopify\/ProductVariant\/(\d+)/g
      let match
      while ((match = regex.exec(this.editBundleVariantIds)) !== null) {
        gids.push(match[0])
      }
      const urlParams = gids.map((gid, index) => {
        return gid
      })
      const url = `${this.editBundleURL}?edit=${urlParams}&remove=${this.editProductId}&quantity=${bundleQuantity}`
      window.location.href = url
    })
  }
  /**
   * Handles the logic for editing a bundle.
   *
   * @return {void} This function does not return a value.
   */
  editBundle() {
    // TODO: Handle edit bundle logic
  }
  loadScript() {
    const script = document.createElement('script')
    script.src = this.scriptSrc + '?ts=' + new Date().getTime()
    script.type = 'module'
    this.bundleItem.appendChild(script)
  }
}

customElements.define('bundle-edit-button', BundleEditButton)
class BundleLineItem extends HTMLElement {
  constructor() {
    super()
    this.bundleLineItem = this
    this.cartLineItemData = this.dataset.cartBundleItem
    this.bundleItem = this.querySelector('.cart-bundle-item')
  }

  connectedCallback() {
    this.loadScript()
  }

  loadScript() {
    const scripts = this.querySelectorAll('script')
    scripts.forEach((oldScript) => {
      const newScript = document.createElement('script')
      Array.from(oldScript.attributes).forEach((attr) => {
        // For the script's src, we need to append a timestamp to prevent caching issues.
        if (attr.name === 'src') {
          newScript.setAttribute(
            attr.name,
            `${attr.value}?ts=${new Date().getTime()}`
          )
        } else {
          newScript.setAttribute(attr.name, attr.value)
        }
      })
      newScript.textContent = oldScript.textContent
      oldScript.parentNode.replaceChild(newScript, oldScript)
    })
  }
}

customElements.define('bundle-line-item', BundleLineItem)

class BundleProductCard extends HTMLElement {
  constructor() {
    super()
    this.bundleProductCard = this
    this.scriptSrc = this.dataset.scriptSrc
  }
  connectedCallback() {
    this.loadScript()
  }

  /**
   * Loads a script dynamically by creating a new script element and appending it to the DOM.
   * The script source is set to the value of the 'scriptSrc' property with a timestamp query parameter.
   * The script type is set to 'module'.
   *
   * @return {void} This function does not return a value.
   */
  loadScript() {
    const script = document.createElement('script')
    script.src = this.scriptSrc + '?ts=' + new Date().getTime()
    script.type = 'module'
    this.bundleProductCard.appendChild(script)
  }
}

customElements.define('bundle-product-card', BundleProductCard)

class BundleProductCardSearch extends HTMLElement {
  constructor() {
    super()
    this.bundleProductCardSearch = this
    this.scriptSrc = this.dataset.scriptSrc
  }
  connectedCallback() {
    this.loadScript()
  }

  /**
   * Loads a script dynamically by creating a new script element and appending it to the DOM.
   * The script source is set to the value of the 'scriptSrc' property with a timestamp query parameter.
   * The script type is set to 'module'.
   *
   * @return {void} This function does not return a value.
   */
  loadScript() {
    const script = document.createElement('script')
    script.src = this.scriptSrc + '?ts=' + new Date().getTime()
    script.type = 'module'
    this.bundleProductCardSearch.appendChild(script)
  }
}

customElements.define('bundle-product-card-search', BundleProductCardSearch)

class CartNote extends HTMLElement {
  constructor() {
    super()
    const detailsCartDrawer = document.getElementById('Details-CartDrawer')
    const cartDrawerItems = document.getElementById('CartDrawer-CartItems')
    const wrappedCartItem = this
    const detailsToggle = detailsCartDrawer.querySelector('summary')

    const handleCartTextareaValidation = (element) => {
      const emojiRegex =
        /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g

      if (emojiRegex.test(element.value)) {
        element.value = element.value.replace(emojiRegex, '').trim()
      }
    }
    detailsToggle.addEventListener('click', function () {
      var giftWrapCheckbox = detailsCartDrawer.querySelector(
        'wrapped-cart-list-provider'
      )
      if (detailsCartDrawer.hasAttribute('open')) {
        giftWrapCheckbox.setAttribute('is-checked', 'false')
      } else {
        giftWrapCheckbox.setAttribute('is-checked', 'true')
      }
    })

    this.addEventListener(
      'change',
      debounce((event) => {
        const body = JSON.stringify({ note: event.target.value })
        fetch(`${routes.cart_update_url}`, {
          ...fetchConfig(),
          ...{ body },
        })
      }, 300)
    )

    this.addEventListener('blur', (event) => {
      handleCartTextareaValidation(event.target)
    })
    this.addEventListener('input', (event) => {
      handleCartTextareaValidation(event.target)
    })

    // Create a mutation observer to observe the DOM and setup custom icons once the widget has been injected
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === 'attributes' &&
          mutation.target.nodeName === 'WRAPPED-FEATURE-VARIANT-SIMPLE' &&
          mutation.addedNodes.length
        ) {
          const messageToggle = cartDrawerItems.querySelector(
            'wrapped-feature-variant-simple'
          )
          this.createMessageListener(messageToggle)
        }
      })
    })

    observer.observe(wrappedCartItem, {
      childList: true,
      subtree: true,
      attributes: true,
    })
  }
  createMessageListener = (messageToggle) => {
    messageToggle.addEventListener('change', (event) => {
      if (detailsCartDrawer.hasAttribute('open')) {
        giftWrapCheckbox.setAttribute('is-checked', 'false')
      } else {
        giftWrapCheckbox.setAttribute('is-checked', 'true')
      }
    })
  }
}
customElements.define('cart-note', CartNote)

const firstFocusableElement = (element) => {
  return element.querySelector(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  )
}

function defer() {
  if (typeof Promise !== 'undefined' && Promise.defer) {
    return Promise.defer()
  } else {
    var deferred = {}
    deferred.promise = new Promise(function (resolve, reject) {
      deferred.resolve = resolve
      deferred.reject = reject
    })
    return deferred
  }
}
